(function () {
    'use strict';

    angular
        .module('garnaCabinet')
        .config(config);

    config.$inject = ['$ocLazyLoadProvider'];

    /* @ngInject */
    function config($ocLazyLoadProvider) {
        var baseHost = 'scripts/bower_components/';
        $ocLazyLoadProvider.config({
            debug: false,
            modules: [
                {
                    name: 'ngImgCrop',
                    files: [baseHost+'ng-img-crop/compile/minified/ng-img-crop.js'],
                    cache: true
                },
                {
                    name: 'flow',
                    files: [baseHost+'ng-flow/dist/ng-flow-standalone.min.js'],
                    cache: true
                },
                {
                    name: 'ngCkeditor',
                    files: [baseHost+'ng-ckeditor/libs/ckeditor/ckeditor.js', baseHost+'ng-ckeditor/ng-ckeditor.js'],
                    serie: true,
                    cache: true
                    //rerun: true,
                    //reconfig: true
                },
                {
                    name: 'ngSticky',
                    files: [baseHost+'ngSticky/dist/sticky.min.js'],
                    cache: true
                },
                {
                    name: 'slick',
                    files: [baseHost+'slick-carousel/slick/slick.css', baseHost+'slick-carousel/slick/slick-theme.css', baseHost+'slick-carousel/slick/slick.min.js'],
                    cache: true
                }
            ]
        });
    }
})();

